import axios from 'axios';
import { IUser } from '../../interfaces';

const { REACT_APP_ME_URL } = process.env;

const me = async (token: string, lang: string) => {
  const response = await axios.get<IUser>(REACT_APP_ME_URL!, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      locale: lang,
    },
  });

  let error;
  if (axios.isAxiosError(response)) {
    error = response.response || response;
  }

  return {
    ...response,
    error,
  };
};

export default me;
